import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ClientsContext from '../../context/clients/clientsContext';
import SubscriptionModal from './ClientSubscriptions';

const ClientItem = ({ client }) => {
  const clientContext = useContext(ClientsContext);
  const { deleteClient, setCurrent, clearCurrent } = clientContext;

  const { id, name, contactName, contactEmail, contactPhone } = client;

  const onDelete = () => {
    deleteClient(id);
    clearCurrent();
  };

  return (
    <div className='card bg-light'>
      <h3 className='text-primart text-left'>
        {name}{' '}
        <span style={{ float: 'right', width: '100px', marginRight: '40px' }}>
          <SubscriptionModal client={client} />
        </span>
      </h3>
      <ul className='list mt-3'>
        {contactName && (
          <li>
            <i className='fas fa-user'></i> {contactName}
          </li>
        )}
        {contactEmail && (
          <li>
            <i className='fas fa-envelope-open'></i> {contactEmail}
          </li>
        )}
        {contactPhone && (
          <li>
            <i className='fas fa-phone'></i> {contactPhone}
          </li>
        )}
      </ul>
      <p>
        <button
          className='btn btn-dark btn-sm'
          onClick={() => setCurrent(client)}
        >
          Edit
        </button>
        <button className='btn btn-danger btn-sm' onClick={onDelete}>
          Delete
        </button>
      </p>
    </div>
  );
};

ClientItem.propTypes = {
  client: PropTypes.object.isRequired
};

export default ClientItem;
